module.exports = __webpack_public_path__ + "media/images/dl-app-store-15f01eefb2013206cc7e26d98fbe95fb.svg";